/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.refreshHandler = this.cartRefreshHandler.bind(this);
    
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
    
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.refreshRelatedProducts();
    });
    
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      // Refresh related products when cart items are updated
      this.refreshRelatedProducts();
    });
    
    // Listen for cart add events
    document.addEventListener('on:cart:add', () => {
      this.refreshRelatedProducts();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
    // Small delay to ensure cart is updated before refreshing related products
    setTimeout(() => {
      this.refreshRelatedProducts();
    }, 100);
  }

  /**
   * Refresh related products
   */
  refreshRelatedProducts() {
    const relatedContainers = document.querySelectorAll('cc-fetched-content.cart-drawer-related-container');
    relatedContainers.forEach(container => {
      if (container && typeof container.refresh === 'function') {
        container.refresh();
      }
    });
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
    // Refresh related products after cart updates
    setTimeout(() => {
      this.refreshRelatedProducts();
    }, 100);
  }
}

window.customElements.define('cart-drawer', CartDrawer);